export function toValidDate(value: unknown): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const date = value instanceof Date ? value : new Date(value as string | number);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function formatDateTimeSafely(value: unknown, fallback = "Data indisponível"): string {
  const date = toValidDate(value);
  return date ? date.toLocaleString("pt-BR") : fallback;
}

export function formatDateSafely(value: unknown, fallback = "—"): string {
  const date = toValidDate(value);
  return date ? date.toLocaleDateString("pt-BR") : fallback;
}
